import AnimationClip from "./animation_clip";

export default class AnimationLibrary {
  private clipsByName = new Map<string, AnimationClip>();
  private clips: AnimationClip[] = [];

  add(clip: AnimationClip): void {
     this.clips.push(clip);
     this.clipsByName.set(clip.name, clip);
  }

   get(name: string): AnimationClip {
    const clip = this.clipsByName.get(name);
    if (!clip) {
      throw new Error(`Animation clip "${name}" not found`);
    }
    return clip;
  }

  getByIndex(index: number): AnimationClip {
    if (index < 0 || index >= this.clips.length) {
      throw new Error(`Animation clip index ${index} out of range`);
    }
    return this.clips[index];
  }

  has(name: string): boolean {
    return this.clipsByName.has(name);
  }

  count(): number {
    return this.clips.length;
  }

  getNameAt(index: number): string {
    return this.getByIndex(index).name;
  }

  getAll(): readonly AnimationClip[] {
    return this.clips;
  }
}
